import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import {
  jumioStart,
  jumioVerification
} from '@/__mocks__/modules/jumio/data.ts'

export default [
  {
    method: 'POST',
    path: '/jumio/start',
    reply: async () => {
      await wait()
      return [status.ok, jumioStart]
    }
  },
  {
    method: 'GET',
    path: '/jumio/verification/2',
    reply: async () => {
      await wait()
      return [status.ok, jumioVerification]
    }
  }
]
